import React from 'react';
import { ReactComponent as XRay } from '../../assets/icons/xRay.svg'
import SvgIcon from '@material-ui/core/SvgIcon'
import { useStyles } from '../report.style'


export const XRayIcon = () => {
    const classes = useStyles();
    return( 
        <SvgIcon 
            component={XRay}  
            className={classes.xRay} 
            viewBox="0 0 122.88 122.88" 
            width="24" 
            height="24" 
        />
    );
}

